import React from "react";
import "./WhatsAppButton.css";
import { FaWhatsapp } from "react-icons/fa";
import TrackedContactLink from "./TrackedContactLink";

export default function Whatsapp() {
  return (
    <TrackedContactLink
      className="whatsapp-button"
      aria-label="Contactar por WhatsApp"
      eventLabel="floating_button"
      kind="whatsapp"
    >
      <FaWhatsapp className="whatsapp-button__icon" />
      <span>¿Cotizamos tu proyecto?</span>
    </TrackedContactLink>
  );
}
